'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _formatting = require('../../utils/formatting');

var _assets = require('../../utils/assets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sf = function sf(num) {
  var format = num > 1000 ? '0a' : '0';
  return (0, _numeral2.default)(num).format(format);
};
var pf = function pf(num) {
  return (0, _numeral2.default)(num).format('0.0%');
};
var DATE_FORMAT = 'LLLL';

var textTransform = {
  textTransform: 'none'
};

var InstagramStoryReport = function InstagramStoryReport(_ref) {
  var story = _ref.story,
      _ref$inManualStoryMod = _ref.inManualStoryMode,
      inManualStoryMode = _ref$inManualStoryMod === undefined ? false : _ref$inManualStoryMod,
      _ref$inGIMode = _ref.inGIMode,
      inGIMode = _ref$inGIMode === undefined ? false : _ref$inGIMode;

  var status = _lodash2.default.get(story, 'attributes.status', 'Unknown');
  var assetType = _lodash2.default.get(story, 'attributes.assetType', _lodash2.default.get(story, 'trackedAsset.assetType'));
  var publishedDate = _lodash2.default.get(story, 'attributes.publishedDate', _lodash2.default.get(story, 'trackedAsset.publishedDate'));
  var caption = _lodash2.default.get(story, 'attributes.caption', _lodash2.default.get(story, 'trackedAsset.extraData.text'));

  var storyMentions = _lodash2.default.get(story, 'attributes.mentions');
  var mentions = _lodash2.default.isArray(storyMentions) ? storyMentions : _lodash2.default.split(storyMentions, ',');

  var storyHashtags = _lodash2.default.get(story, 'attributes.hashtags');
  var hashtags = _lodash2.default.isArray(storyHashtags) ? storyHashtags : _lodash2.default.split(storyHashtags, ',');

  var username = _lodash2.default.get(story, 'attributes.username', _lodash2.default.get(story, 'influencerName'));
  var isVideo = assetType === 'VIDEO';
  var latest = _lodash2.default.last(_lodash2.default.get(story, 'attributes.storyData', []));
  var supportingData = _lodash2.default.get(story, 'relationships.supportingData') || _lodash2.default.get(story, 'trackedAsset.supportingData');

  var manualImps = (0, _assets.getSupportingDataField)(supportingData, 'impressions');
  var manualReach = (0, _assets.getSupportingDataField)(supportingData, 'reach');

  var isBoosted = !_lodash2.default.isNull(_lodash2.default.get(story, 'attributes.finalImps', null));

  var completionRate = inManualStoryMode || inGIMode || isBoosted || !latest || !latest.impressions || !latest.exits ? null : (latest.impressions - latest.exits) / latest.impressions;

  var pubDate = (0, _moment2.default)(publishedDate).format(DATE_FORMAT);
  var expDate = (0, _moment2.default)(publishedDate).add(1, 'day').format(DATE_FORMAT);

  var imps = _lodash2.default.get(story, 'attributes.finalImps') || latest ? _lodash2.default.get(latest, 'impressions') : _lodash2.default.get(story, 'insights.impressions');
  var reach = _lodash2.default.get(story, 'attributes.finalReach') || latest ? _lodash2.default.get(latest, 'reach') : _lodash2.default.get(story, 'insights.reach');

  var s3Url = (0, _assets.getS3Url)((0, _assets.getSupportingDataField)(supportingData, 'filePath'));
  var savedThumbnailUrl = _lodash2.default.get(story, 'attributes.savedThumbnailUrl', s3Url);
  var savedMediaUrl = _lodash2.default.get(story, 'attributes.savedMediaUrl', s3Url);

  console.log(s3Url);

  var imageUrl = savedThumbnailUrl || savedMediaUrl;

  var storyImage = imageUrl ? _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: isVideo ? 'film' : 'image', size: 'massive', color: 'pink' });

  var StoryVideo = function StoryVideo() {
    return _react2.default.createElement(
      'div',
      null,
      _lodash2.default.isNil(savedMediaUrl) && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_semanticUiReact.Image, { src: imageUrl, size: 'large' }),
        _react2.default.createElement(
          'span',
          null,
          'Video not available'
        )
      ),
      _lodash2.default.isNil(savedMediaUrl) && (0, _assets.isVideoUrl)(savedThumbnailUrl) && _react2.default.createElement(_reactPlayer2.default, { url: savedThumbnailUrl, width: '100%', height: '100%', controls: true }),
      savedMediaUrl && _react2.default.createElement(_reactPlayer2.default, { url: savedMediaUrl, width: '100%', height: '100%', controls: true })
    );
  };

  var storyContent = isVideo || (0, _assets.isVideoUrl)(s3Url) || (0, _assets.isVideoUrl)(savedThumbnailUrl) ? _react2.default.createElement(StoryVideo, null) : storyImage;

  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { columns: 2 },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 5, verticalAlign: 'top' },
        storyContent
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 11 },
        !inGIMode && _react2.default.createElement(
          _semanticUiReact.Card,
          { fluid: true },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Statistic.Group,
              { widths: inManualStoryMode ? 'two' : 'three' },
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  (0, _formatting.sciFormatted)(inManualStoryMode ? manualImps : imps)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'Impressions'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  (0, _formatting.sciFormatted)(inManualStoryMode ? manualReach : reach)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'Reach'
                )
              ),
              completionRate && _react2.default.createElement(
                _semanticUiReact.Statistic,
                { color: 'teal' },
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  pf(completionRate)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'Completion Rate \xA0',
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    content: 'Completion rate is calculated as the percentage of users who viewed the story and did NOT exit the story.', trigger: _react2.default.createElement(_semanticUiReact.Icon, {
                      className: 'circular',
                      name: 'help',
                      color: 'teal'
                    })
                  })
                )
              )
            )
          )
        ),
        !inManualStoryMode && !inGIMode && _react2.default.createElement(
          _semanticUiReact.Card,
          { fluid: true },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table,
              { basic: 'very', textAlign: 'center', columns: 'four' },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'TAPS FORWARD'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'TAPS BACK'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'REPLIES'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    'EXITS'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'taps_forward'))
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'taps_back'))
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'replies'))
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    (0, _formatting.commaFormatted)(_lodash2.default.get(latest, 'exits'))
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card,
          { fluid: true },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table,
              { basic: 'very', celled: true, fluid: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'INFLUENCER'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    username
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'POSTED'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    pubDate
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'CAPTION'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    caption || 'no caption created'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        '@MENTIONS'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _lodash2.default.map(mentions, function (mention) {
                      if (!_lodash2.default.isEmpty(mention)) {
                        return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'pink', content: _lodash2.default.toLower(mention) });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        '#HASHTAGS'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _lodash2.default.map(hashtags, function (hashtag) {
                      if (!_lodash2.default.isEmpty(hashtag)) {
                        return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'green', content: _lodash2.default.toLower(hashtag) });
                      }
                    })
                  )
                )
              )
            )
          )
        )
      )
    )
  );
};

InstagramStoryReport.propTypes = {
  story: _propTypes2.default.object.isRequired
};

exports.default = InstagramStoryReport;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-story-report/index.js
 ** module id = 2600
 ** module chunks = 0
 **/